import React, {useEffect, useState} from 'react';
import axios from "axios";
import {toast} from "react-toastify";
import Modal from "react-modal";
import Button from "../components/Button";

const DuplicateJobProductModal = (props) => {
    const {
        jobId       = null,
        productId   = null,
        show        = false,
        parentId    = "",
        disabled    = false,
        onCancel    = () => {},
        onComplete  = (product) => {},
        id          = "duplicate-job-product-modal",
    } = props;

    const [submitting, setSubmitting]   = useState(false);
    const [job, setJob]                 = useState(null);
    const [product, setProduct]         = useState(null);
    const [errors, setErrors]           = useState(null);

    useEffect(() => {
        if (!!jobId && !!productId) {
            load(false);
        }
    }, [jobId, productId]);

    const load = () => {
        axios.get(route('web-api.job.product.config', {job: jobId, product_id: productId}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.job) {
                        setJob(response.data.job);
                    }

                    if (!!response.data.product) {
                        setProduct(response.data.product);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
                setSubmitting(false);
            });
    }

    useEffect(() => {
        if (!!submitting) {
            submit();
        }
    }, [submitting]);

    const reset = () => {
        setJob(null);
        setProduct(null);

        setSubmitting(false);
    }

    const payload = () => {
        return {
            method: 'post',
            url:    route('web-api.job.product.duplicate', {job: jobId, product: productId}).toString(),
        }
    }

    const submit = () => {
        axios(payload())
            .then((response) => {
                reset();
                onComplete(response.data.product_id);
            })
            .catch((error) => {
                console.log(error);
                if (!!error.response.data && !!error.response.data.errors) {
                    setErrors(error.response.data.errors);
                    toast.error(<div>{!!error.response.data.message ? error.response.data.message : "An error occurred"}</div>);
                }

                setSubmitting(false);
            });
    }

    const handleClose = () => {
        if (!submitting) {
            reset();
            onCancel();
        }
    }

    return (
        <React.Fragment>
            <Modal
                ariaHideApp={false}
                isOpen={show}
                parentSelector={() => document.getElementById(parentId)}
                onRequestClose={() => handleClose()}
                contentLabel={"Duplicate Product"}
                className={'ReactModal__Content react-modal-outer modal-dialog admin-modal wide-modal allow-overflow'}
                style={{
                    overlay: {
                        width: '100vw',
                        height: '100vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        overflow: 'hidden',
                        outline: 'none',
                    },
                    content: {
                        width: "100%",
                        height: "100%",
                        padding: 0,
                        border: 0,
                        outline: 'none',
                    },
                }}
            >
                <div className="p-4 modal-content" id={id}>
                    <div className="modal-header border-0 m-0 p-0 pb-4">
                        <h4 className="modal-title text-eh-navy">{"Duplicate Product"}</h4>
                        <button
                            type="button" className="close"
                            data-dismiss="modal" aria-label="Close"
                            onClick={() => handleClose()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body m-0 mb-3 p-0">
                        <div className="border-bottom mb-3">
                            {!!job && (
                                <div className="row m-0 p-0">
                                    <div className="col-12 col-md-6 m-0 p-0 pr-md-2">
                                        <p className="mb-0 text-eh-off-black"><strong>Job Name</strong></p>
                                        <p className="text-eh-off-black">{!!job && !!job.name ? job.name : "-"}</p>
                                    </div>
                                </div>
                            )}
                            {!!product && (
                                <React.Fragment>
                                    <div className="row m-0 p-0">
                                        <div className="col-12 col-md-6 m-0 p-0 pr-md-2">
                                            <p className="mb-0 text-eh-off-black"><strong>Product Name</strong></p>
                                            <p className="text-eh-off-black">{!!product && !!product.name ? product.name : "-"}</p>
                                        </div>
                                        <div className="col-12 col-md-6 m-0 p-0 pl-md-2">
                                            <p className="mb-0 text-eh-off-black"><strong>Product Type</strong></p>
                                            <p className="text-eh-off-black">{!!product && !!product.product_type_name ? product.product_type_name : "-"}</p>
                                        </div>
                                    </div>
                                    <div className="row m-0 p-0">
                                        <div className="col-12 col-md-6 m-0 p-0 pr-md-2">
                                            <p className="mb-0 text-eh-off-black"><strong>Product Quantity</strong></p>
                                            <p className="text-eh-off-black">{!!product && !!product.quantity ? product.quantity : "-"}</p>
                                        </div>
                                        <div className="col-12 col-md-6 m-0 p-0 pl-md-2">
                                            <p className="mb-0 text-eh-off-black"><strong>Product Price</strong></p>
                                            <p className="text-eh-off-black">{!!product && !!product.price ? product.price : "-"}</p>
                                        </div>
                                    </div>
                                    <div className="row m-0 p-0">
                                        <div className="col-12 m-0 p-0">
                                            <p className="mb-0 text-eh-off-black"><strong>Product Description</strong></p>
                                            <p className="text-eh-off-black">{!!product && !!product.description ? product.description : "-"}</p>
                                        </div>
                                    </div>
                                    <div className="row m-0 p-0">
                                        <div className="col-12 col-md-6 m-0 p-0 pr-md-2">
                                            <p className="mb-0 text-eh-off-black"><strong>Line Items</strong></p>
                                            <p className="text-eh-off-black">{!!product && !!product.product_line_items ? product.product_line_items.length : "-"}</p>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                        <div className="row m-0 p-0">
                            <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center">
                                <div className="d-flex justify-content-start align-items-center">
                                    <Button
                                        onClick={() => setSubmitting(true)}
                                        label={"Duplicate Product"}
                                        classes={"btn btn-eh-lilac m-0 mr-4"}
                                    />
                                    <Button
                                        onClick={() => handleClose()}
                                        label={"Cancel"}
                                        classes={"btn btn-outline-eh-off-black m-0 mr-4"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    );
}

export default DuplicateJobProductModal;
